import script from "./BaseSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSection.vue?vue&type=script&setup=true&lang=js"

import "./BaseSection.vue?vue&type=style&index=0&id=1c3c38ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3c38ba"]])

export default __exports__